import { Injectable } from '@angular/core';
import { ApiError, IsError, IsErrorValues } from '@app-lib';
import { HotToastService } from '@ngneat/hot-toast';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  constructor(private _toast: HotToastService) {}
  // ========== TOASTER =========== //
  ShowApiError(x: ApiError) {
    let tmessage = `
             ${x.Message}<br />`;
    if (x.Code) {
      tmessage += `code:  <b>${x.Code}</b><br />`;
    }
    if (x.Reference) {
      tmessage += `ref:  ${x.Reference}<br />`;
    }
    if (x.ServerResponse) {
      tmessage += `ref:  ${x.ServerResponse}<br />`;
    }
    tmessage += `<br />`;

    if (x.Continue && x.Continue == true) {
      return this._toast.warning(tmessage, {
        dismissible: true,
        duration: 5000,
      });
    } else {
      return this._toast.error(tmessage, {
        autoClose: false,
        dismissible: true,
      });
    }
  }
  // -- //

  ShowIsError(x: IsError | IsErrorValues) {
    let tmessage = `
            ${x.Message}  <br />
            code: <b>${x.Code} </b>
            <br />`;

    if (x.Continue && x.Continue == true) {
      return this._toast.warning(tmessage, {
        dismissible: true,
        duration: 5000,
      });
    } else {
      return this._toast.error(tmessage, {
        autoClose: false,
        dismissible: true,
      });
    }
  }

  ToastError(message: string) {
    return this._toast.error(message, {
      autoClose: false,
      dismissible: true,
    });
  }
  ToastInfo(message: string) {
    return this._toast.info(message, {
      dismissible: true,
      duration: 4000,
    });
  }
  ToastSuccess(message: string) {
    return this._toast.success(message, {
      dismissible: true,
      duration: 4000,
    });
  }
  ToastWarning(message: string) {
    return this._toast.warning(message, {
      dismissible: true,
      duration: 8000,
    });
  }
  ToastShow(title: string, message: string) {
    const msg = `<h5 class="text-secondary">${title}</h5>
                  <p>${message}</p>`;

    return this._toast.info(msg, {
      dismissible: true,
      duration: 10000,
    });
  }
}
